export interface BarPasswordStrongProps {
  forceScore: 0 | 1 | 2 | 3 | 4;
}

export enum PasswordStrengthLevel {
  Warning = 'warning',
  Danger = 'danger',
  Success = 'success',
}
